const STYLES = {
  federal: "bg-blue-50 text-blue-700 border-blue-200",
  state: "bg-emerald-50 text-emerald-700 border-emerald-200",
  county: "bg-amber-50 text-amber-700 border-amber-200",
  city: "bg-orange-50 text-orange-700 border-orange-200",
};

export function LevelBadge({ level }) {
  const l = (level || "state").toLowerCase();
  return (
    <span className={`font-mono text-[10px] uppercase tracking-widest px-2 py-0.5 rounded border ${STYLES[l] || STYLES.state}`}>
      {l}
    </span>
  );
}

export function StatusBadge({ status, map, testid }) {
  const s = map[status] || { label: status, cls: "bg-slate-100 text-slate-600 border-slate-200" };
  return (
    <span data-testid={testid} className={`text-xs font-medium px-2.5 py-1 rounded-full border ${s.cls}`}>
      {s.label}
    </span>
  );
}

const utc = (s) => (s && !/[zZ]|[+-]\d\d:?\d\d$/.test(s) ? `${s}Z` : s);

export const isOverdue = (r) => r.paid !== false && !["certified", "awaiting_payment"].includes(r.status) &&
  Date.now() - new Date(utc(r.submitted_at || r.created_at)) >= 48 * 3600000;

export function TurnaroundBadge({ r, testid }) {
  const start = utc(r.submitted_at || r.created_at);
  if (!start || r.status === "awaiting_payment") return null;
  const end = r.status === "certified" ? utc(r.certified_at || r.updated_at) : null;
  const hours = Math.max(0, Math.floor((new Date(end || Date.now()) - new Date(start)) / 3600000));
  const txt = hours < 48 ? `${hours}h` : `${Math.floor(hours / 24)}d ${hours % 24}h`;
  if (end) return <span data-testid={testid} className="text-[11px] font-medium px-2 py-0.5 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-200">Done in {txt}</span>;
  const late = hours >= 48;
  return <span data-testid={testid} className={`text-[11px] font-medium px-2 py-0.5 rounded-full border ${late ? "bg-red-50 text-red-700 border-red-200 animate-pulse" : hours >= 36 ? "bg-amber-50 text-amber-700 border-amber-200" : "bg-slate-50 text-slate-600 border-slate-200"}`}>{late ? `Overdue · open ${txt}` : `Open ${txt} · 48h target`}</span>;
}
